import { useCalculationStore } from '@/stores/calculation'
import { storeToRefs } from 'pinia'
import type {
  CalculationFormMixinProps,
  CalculationFormTab
} from '@/components/calculation-form/type/type'
import { computed, ref, watch } from 'vue'

export function useCalculationFormComposable(
  props: CalculationFormMixinProps,
  emit: (event: 'updateTabCompletion', value: CalculationFormTab, isCompleted: boolean) => void
) {
  const calculationStore = useCalculationStore()
  const { currentItem } = storeToRefs(calculationStore)

  const isValid = ref()
  const formRef = ref()

  const hasHelpText = (field: string) => {
    return !!calculationStore.fields[field]?.help_text
  }

  function lowerValidator(value: number, key: string) {
    const upper_key = key.replace('lower', 'upper')
    return value > currentItem.value[upper_key] ? 'Invalid' : true
  }

  function upperValidator(value: number, key: string) {
    const lower_key = key.replace('upper', 'lower')
    return value < currentItem.value[lower_key] ? 'Invalid' : true
  }

  watch(isValid, () => {
    emit('updateTabCompletion', props.tab, isValid.value)
  })

  watch(currentItem, () => {
    isValid.value = false
  })

  const isReadOnly = computed(() => {
    return !calculationStore.canChangeCalculation || props.readonly
  })

  return {
    ...props,
    calculationStore,
    currentItem,
    isValid,
    isReadOnly,
    formRef,
    hasHelpText,
    lowerValidator,
    upperValidator
  }
}
